import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AnnotationsModule } from '®shared/annotations';
import { CurrentUserModule } from '®shared/current-user';
import { DashboardAnalyticsModule } from '®shared/dashboard-analytics';
import { EventsModule } from '®shared/events';
import { InlineNoteModule } from '®shared/inline-note';
import { ItemMetadataModule } from '®shared/item-metadata';
import {
  FieldedItemModule,
  OnlineResourcesModule,
  ViewItemMenuModule,
} from '®shared/list-item';
import { PageContentModule } from '®shared/list-item/resource/page-content';
import { ShareSheetModule } from '®shared/list-item/share-sheet';
import { AvailabilityModule } from '®shared/resource-availability';
import { UriModule } from '®shared/url-utils';
import { UserSubscribedResourcesModule } from '®shared/user/subscribed-resources';
import { VirtualisationModule } from '®shared/virtualisation';

import { ContainerStructureCommonModule } from '../common';
import { ContainerStateModule } from '../state';

import { ViewContainerNodeComponent } from './view-container-node.component';
import { ViewContainerComponent } from './view-container.component';
import { ViewItemComponent } from './view-item.component';
import { ViewItemSmartComponent } from './view-item.smart-component';
import { ViewSectionComponent } from './view-section.component';

@NgModule({
  imports: [
    AnnotationsModule,
    AvailabilityModule,
    ContainerStateModule,
    ContainerStructureCommonModule,
    CommonModule,
    CollapseModule,
    CurrentUserModule,
    DashboardAnalyticsModule,
    EventsModule,
    FieldedItemModule,
    InlineNoteModule,
    ItemMetadataModule,
    ModalModule,
    OnlineResourcesModule,
    PageContentModule,
    ShareSheetModule,
    UserSubscribedResourcesModule,
    ViewItemMenuModule,
    VirtualisationModule,
    UriModule,
  ],
  declarations: [
    ViewContainerComponent,
    ViewContainerNodeComponent,
    ViewItemComponent,
    ViewItemSmartComponent,
    ViewSectionComponent,
  ],
  exports: [
    ViewContainerComponent,
    ViewContainerNodeComponent,
    ViewItemComponent,
    ViewItemSmartComponent,
    ViewSectionComponent,
  ],
})
export class ContainerStructureViewModule {}
